"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcAttachmentsPanel = class UcAttachmentsPanel extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    parent_id;
    onParent_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent_id");
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    container;
    async $$load_container() {
        return this.$fn.fetch('list_attachment', { parameters: { 'owner-id': this.parent_id || this.parent.id }, asResourceContainer: true });
    }
    ux;
    dataMembers = ['container', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                container: null,
                ux: null,
            },
        };
    }
    get items() {
        if (this.loaded) {
            return this.container.data;
        }
        return null;
    }
    get isReadOnly() {
        if (this.loaded) {
            return this.readonly || (this.parent && this.parent.isReadOnly);
        }
        return null;
    }
    async act_5382094220310827_showModal_3164_getActionArgs($event) {
        return {
            name: "WAttachmentModal",
            props: {
                object_id: this.parent_id || this.parent.id,
                attachment: _.cloneDeep($event.scope.item),
            },
        };
    }
    async evh_5382094220310827_clickPreventStop(event, scope) {
        return await this.actions.evh_5382094220310827_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2688566256707306_request_3168_getActionArgs($event) {
        return {
            operation: "delete_attachment",
            data: $event.scope.item,
        };
    }
    async act_2688566256707306_request_3168_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_2688566256707306_clickPreventStop(event, scope) {
        return await this.actions.evh_2688566256707306_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_showModal_3172_getActionArgs($event) {
        return {
            name: "WAttachmentModal",
            props: {
                object_id: this.parent_id || this.parent.id,
            },
        };
    }
    async evh_5962862420439144_clickPreventStop(event, scope) {
        return await this.actions.evh_5962862420439144_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5382094220310827_reloadComponentData_3166 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5382094220310827_close_3165 = new core_1.actions.EventHandlerImpl({
            action: act_5382094220310827_reloadComponentData_3166,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_5382094220310827_showModal_3164 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5382094220310827_showModal_3164_getActionArgs,
            events: [evh_5382094220310827_close_3165],
        });
        const evh_5382094220310827_clickPreventStop_3163 = new core_1.actions.EventHandlerImpl({
            action: act_5382094220310827_showModal_3164,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_5382094220310827_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5382094220310827_clickPreventStop_3163],
        });
        const act_2688566256707306_reloadComponentData_3170 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2688566256707306_success_3169 = new core_1.actions.EventHandlerImpl({
            action: act_2688566256707306_reloadComponentData_3170,
            event: "success",
            displayName: "reloadComponentData",
        });
        const act_2688566256707306_request_3168 = new core_1.actions.RequestAction({
            actionArgs: this.act_2688566256707306_request_3168_getActionArgs,
            confirm: this.act_2688566256707306_request_3168_getConfirm,
            events: [evh_2688566256707306_success_3169],
        });
        const evh_2688566256707306_clickPreventStop_3167 = new core_1.actions.EventHandlerImpl({
            action: act_2688566256707306_request_3168,
            event: "click.prevent.stop",
            displayName: "request",
        });
        const evh_2688566256707306_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2688566256707306_clickPreventStop_3167],
        });
        const act_5962862420439144_reloadComponentData_3174 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5962862420439144_close_3173 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_reloadComponentData_3174,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_5962862420439144_showModal_3172 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5962862420439144_showModal_3172_getActionArgs,
            events: [evh_5962862420439144_close_3173],
        });
        const evh_5962862420439144_clickPreventStop_3171 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_showModal_3172,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_5962862420439144_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_clickPreventStop_3171],
        });
        return {
            act_5382094220310827_reloadComponentData_3166,
            evh_5382094220310827_close_3165,
            act_5382094220310827_showModal_3164,
            evh_5382094220310827_clickPreventStop_3163,
            evh_5382094220310827_clickPreventStop,
            act_2688566256707306_reloadComponentData_3170,
            evh_2688566256707306_success_3169,
            act_2688566256707306_request_3168,
            evh_2688566256707306_clickPreventStop_3167,
            evh_2688566256707306_clickPreventStop,
            act_5962862420439144_reloadComponentData_3174,
            evh_5962862420439144_close_3173,
            act_5962862420439144_showModal_3172,
            evh_5962862420439144_clickPreventStop_3171,
            evh_5962862420439144_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcAttachmentsPanel.prototype, "parent_id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent_id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAttachmentsPanel.prototype, "onParent_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcAttachmentsPanel.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAttachmentsPanel.prototype, "onParent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcAttachmentsPanel.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAttachmentsPanel.prototype, "onReadonly", null);
UcAttachmentsPanel = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcAttachmentsPanel);
exports.default = UcAttachmentsPanel;
vue_property_decorator_1.Vue.component("UcAttachmentsPanel", UcAttachmentsPanel);
